export default __webpack_public_path__ + "static/media/FirstConnect.99f8554e.png";